import { Center, Spinner } from "@chakra-ui/react"

export const CenteredSpinner = () => (
	<Center>
		<Spinner />
	</Center>
)
